import { motion } from "framer-motion";
import { fadeUp, LOGO_DIAMOND, IMAGES } from "@/lib/site";

const STEPS = [
  {
    n: "01",
    title: "Analiza i strategija",
    body:
      "Upoznajemo vašu kliniku, usluge i ciljanog klijenta. Postavljamo mjerljive ciljeve prije nego što se potroši i euro.",
    img: "/office/analyze.webp",
  },
  {
    n: "02",
    title: "Postavljanje i pokretanje",
    body:
      "Kreiramo oglase, ciljanje i praćenje konverzija. Sve je transparentno — u svakom trenutku znate gdje ide budžet.",
    img: "/office/setup.webp",
  },
  {
    n: "03",
    title: "Optimizacija i izvještaji",
    body:
      "Kontinuirano snižavamo cijenu upita i skaliramo ono što radi. Redoviti, jasni izvještaji bez marketinškog mudroslovlja.",
    img: "/office/optimize.webp",
  },
];

export default function TeamProcess() {
  return (
    <section id="o-nama" className="relative z-10 bg-[#050505] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mb-6 flex items-center gap-3">
          <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
          <span className="eyebrow">Tim i proces</span>
        </motion.div>
        <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mb-6 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
          Iza svega stoji stvaran tim
        </motion.h2>
        <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mb-20 max-w-2xl text-base leading-relaxed text-white/55">
          Ne skrivamo se iza bezličnog imena agencije. Iza svake kampanje stoji tim specijaliziranih
          freelance stručnjaka — svatko pokriva svoj sektor, od strategije i kreative do optimizacije i analitike,
          kroz precizne i provjerene procese. Radimo s malim brojem klinika kako bismo svakoj posvetili punu pažnju.
        </motion.p>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          className="mb-20 grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-16"
        >
          <div className="relative aspect-[4/5] max-w-sm overflow-hidden border border-[#222]">
            <img
              src="/office/founder.webp"
              alt="Ante Budimir — osnivatelj Onarf Marketinga"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="flex flex-col gap-4">
            <span className="flex items-center gap-3 eyebrow">
              <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
              Osnivatelj
            </span>
            <p className="max-w-md text-lg font-medium leading-relaxed text-white/70">
              „Onarf je nastao iz frustracije. Gledao sam previše klinika koje plaćaju
              agencijama koje ne razumiju njihov posao. Zato sam svojim klijentima odlučio dostaviti
              rezultate kakve zaslužuju."
            </p>
          </div>
        </motion.div>

        <div className="flex flex-col gap-px">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className={`grid grid-cols-1 items-center gap-8 border-t border-[#222] py-12 md:grid-cols-2 md:gap-16 ${
                i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
              }`}
            >
              <div className="flex flex-col gap-5">
                <span className="font-display text-7xl font-black text-[#1c1c1c]">{s.n}</span>
                <h3 className="flex items-center gap-3 font-display text-2xl font-bold uppercase tracking-tight text-white md:text-3xl">
                  <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
                  {s.title}
                </h3>
                <p className="max-w-md text-base leading-relaxed text-white/55">{s.body}</p>
              </div>
              <div className="relative aspect-[4/3] overflow-hidden border border-[#222]">
                <img
                  src={s.img}
                  alt="[PLACEHOLDER — fotografija iz ureda]"
                  className="h-full w-full object-cover grayscale"
                />
                <div className="absolute inset-0 bg-[#50C878]/5" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
